import axios from 'axios'
import { i18n } from '../../plugins/i18n'

import { camelCase, toSnakeCase } from '../../modules/string_converter'

export const companiesInitialSetupGuides = {
  namespaced: true,
  state: {
    data: null,
    loading: false,
  },
  getters: {
    noCountKeys() {
      return [
        'analysisReviewKeywordRegistered'
      ]
    },
    unconfirmedCount(state, getters, rootState, rootGetters) {
      if(state.loading) return 0
      let count = Object.entries(state.data).filter(([key, v]) => {
        // キーワード機能が提供されていないプランでの設定済みかどうかはカウントしない
        if (!rootGetters['companiesCompany/providedFeaturesAnalysisKeyword'] && getters.noCountKeys.includes(key)) return false
        if (!rootGetters['companiesCompany/providedFeaturesVisitor'] && key === 'storeVisitorPageConfirmed') return false
        // biz側からの要望により、一旦表示しないので設定にも反映しない
        if (key === 'storeExternalAccountRegistered') return false

        return v === false
      }).length
      return count
    },
    showInitialSettingGuide(state) {
      return !state.loading && state.data !== null
    }
  },
  mutations: {
    prepareConnect(state) {
      state.loading = true
    },
    apiSuccess(state, payload) {
      // セルフサーブユーザー以外はnullが帰る
      if (payload.data !== null) {
        const result  = {}
        for (const [key, value] of Object.entries(payload.data.attributes)) {
          result[camelCase(key)] = value
        }
        state.data = result
      }
      state.loading = false
    },
    apiFailure(state) {
      state.loading = false
    },
  },
  actions: {
    readInitialSettingGuideConfirmations({ rootState,commit, state }) {
      if (state.loading) return

      commit('prepareConnect')

      return axios
        .get('/api/companies/' + rootState.route.params.company_uuid + '/initial_setup_guides.json')
        .then((res) => {
          commit('apiSuccess', res.data)
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
        })
    },
    completeSetupGuide({ rootState, commit, state }, guideKey) {
      if (state.loading) return

      commit('prepareConnect')
      // backendではガイドのカラムは日付カラムのため_atを追加して実行
      const payload = { initial_setup_guide: { guide: toSnakeCase(guideKey) +'_at' } }

      return axios
        .put('/api/companies/' + rootState.route.params.company_uuid + '/initial_setup_guides/complete', payload)
        .then((res) => {
          commit('flash/updateFlash', { type: 'notice', message: i18n.t('messages.updated', { value: i18n.t('models.initialSetupGuide.modelName') }) }, { root: true })
          commit('apiSuccess', res.data)
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
        })
    },
  },
}
